import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {NoticeService} from "./services/NoticeService";
import Swal from "sweetalert2";
import {FormatDateTime} from "./helpers/FormatDateTime";
import truncate from "html-truncate";
import {NewLoading} from "./components/NewLoading";

const ShowNotice = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { getNotice } = NoticeService();

    const [notice, setNotice] = useState(null);
    const [noticeLoading, setNoticeLoading] = useState(false);

    useEffect(() => {

        const getNoticeLoader = async () => {

            setNoticeLoading(true);
            const response = await getNotice(id);
            if (!response) {
                await Swal.fire({
                    title: "Oops!",
                    text: "Nóticia não encontrada.",
                    icon: "error"
                });
                navigate('/');
                return;
            }
            setNotice(response);
            setNoticeLoading(false);

        };

        getNoticeLoader();
    }, [id]);

    return (
        <div className="flex items-center justify-center p-4 news-page">
            <div className="news-container bg-white w-full max-w-4xl">
                {/*Header*/}
                <div className="bg-gray-800 text-white px-8 py-6 flex items-center justify-between">
                    <div className="flex items-center">
                        <div className="w-14 h-14 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                            <i className="fas fa-newspaper text-white text-2xl"></i>
                        </div>
                        <h1 className="text-3xl font-bold">DDtank <span className="text-blue-300">Notícias</span></h1>
                    </div>
                    <a href="/" className="flex items-center text-blue-300 hover:text-blue-100">
                        <i className="fas fa-arrow-left mr-2"></i>
                        <span>Voltar</span>
                    </a>
                </div>

                {/*News Content*/}
                <div className="p-8">
                    {
                        !noticeLoading ? (
                            <>
                                {/*News Header*/}
                                <div className="mb-8 border-b border-gray-200 pb-6">
                                    <div className="flex items-center mb-4">
                                        <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3">
                                            <i className="fa-solid fa-bullhorn"></i>
                                        </div>
                                        <span className="text-sm text-gray-500">{FormatDateTime(notice?.created_at)}</span>
                                    </div>

                                    <h2 className="text-3xl font-bold text-gray-800 mb-4">{notice?.title}</h2>

                                    <div className="flex items-center text-sm text-gray-500">
                                        <i className="fas fa-user mr-2"></i>
                                        <span>Por: Equipe DDtank Splush</span>
                                    </div>
                                </div>

                                {/*News Body*/}
                                <div className="news-content text-gray-700 mb-8">
                                    {
                                        <p dangerouslySetInnerHTML={{__html: notice?.content}}>
                                        </p>
                                    }
                                </div>

                                {/*Back Button*/}
                                <div className="text-center">
                                    <a href="/"
                                       className="btn-back inline-flex items-center px-6 py-3 text-white font-medium rounded-lg">
                                        <i className="fas fa-arrow-left mr-2"></i>
                                        Voltar para a página inicial
                                    </a>
                                </div>
                            </>
                        ) : (
                            <div className={"flex items-center justify-center"}>
                                <NewLoading></NewLoading>
                            </div>
                        )
                    }
                </div>

                {/*Footer*/}
                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © 2025 - Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShowNotice;